import { render, staticRenderFns } from "./TgbButton.vue?vue&type=template&id=b49873bc"
import script from "./TgbButton.vue?vue&type=script&lang=js"
export * from "./TgbButton.vue?vue&type=script&lang=js"
import style0 from "./TgbButton.vue?vue&type=style&index=0&id=b49873bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports